export function constants(): string {
  return 'constants';
}

export const noop = () => undefined;
export const noobj = {};
export const noarr = [];
export const nostr = '';

export const STORAGE_ASSET_APP_DEEPORIUM_PATH = 'apps/static-pages/deeporium';
export const STORAGE_ASSET_APP_TV_PLAYER_PATH = 'apps/static-pages/tv-player';

export const STORAGE_ASSET_FONTS_PATH = 'fonts';
export const STORAGE_ASSET_ICONS_PATH = 'icons';
export const STORAGE_ASSET_IMAGES_PATH = 'images';

export const DIALING_CODE = '+84';
export const COUNTRY = 'Việt Nam';
